<template>
  <div class="code-scanner-wrapper">
    <v-quagga
    :onDetected="logIt"
    :readerTypes="readerTypes"
    ref="scanner" />
    <div class="scanner-identifier" v-show="identifier"><span class="text">{{identifier}}</span></div>
  </div>
</template>

<script>
export default {
  name: 'CodeScanner',
  props: {
    identifier: {
      type: String,
      default: () => ''
    },
    readerTypes: {
      type: Array,
      default: () => [
        'code_128_reader',
        'ean_reader',
        'ean_8_reader',
        'code_39_reader',
        'code_39_vin_reader',
        'codabar_reader',
        'upc_reader',
        'upc_e_reader',
        'i2of5_reader',
        '2of5_reader',
        'code_93_reader'
      ]
    }
  },
  methods: {
    logIt (data) {
      return this.$emit('onDetected', data)
    }
  }
}
</script>
